import * as React from 'react';
import thousands from 'thousands';
import './_summary.scss';
import EventService from '../calculationComponents.eventservice';

export interface SummaryProps {
  list: SummaryList[];
}

export interface SummaryState {
  list: SummaryViewList[];
}

export interface SummaryList {
  Label: string;
  Id: string;
}
export interface SummaryViewList extends SummaryList {
  Value: string;
}

export class Summary extends React.Component<SummaryProps, SummaryState> {
  constructor(props: SummaryProps) {
    super(props);
    this.state = {
      list: this.initializeList()
    };
  }

  initializeList = () => {
    return this.props.list.map(item => {
      return {
        Label: item.Label,
        Id: item.Id,
        Value: ''
      } as SummaryViewList;
    });
  };

  componentDidMount = () => {
    this.props.list.forEach((elem, index) => {
      EventService.subscribe(`cell-updated:${elem.Id}`, (e: CustomEvent) => {
        let clone = this.state.list.slice();
        clone.find(x => x.Id === elem.Id).Value = e.detail;
        this.setState({
          list: clone
        });
      });
    });
  };

  renderList = (list: SummaryViewList, index: number) => {
    return (
      <div key={index} className="summary__row">
        <div className="summary__col1 like-a-label">{list.Label}</div>
        <div className="summary__col2 like-a-label">{thousands(list.Value, ' ')}</div>
      </div>
    );
  };

  public render() {
    const { list } = this.state;
    return <div className="summary cc-component">{list && list.map(this.renderList)}</div>;
  }
}
